import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixToast from '@radix-ui/react-toast';
import { useAtomValue, useSetAtom } from 'jotai';
import { ToastMapActionTypes } from '../../constants/index.js';
import { selectToastList, toastMapState } from '../../state/toast-map.js';
import './toast-stack.css';
import closeIcon from '../../imgs/close-icon.svg';
import alertErrorIcon from '../../imgs/alert-error-icon.svg';
import alertInfoIcon from '../../imgs/alert-info-icon.svg';
import alertSucessIcon from '../../imgs/alert-success-icon.svg';
import alertWarningIcon from '../../imgs/alert-warning-icon.svg';
import alertDefaultIcon from '../../imgs/alert-default-icon.svg';
const ICON_MAP = {
    error: alertErrorIcon,
    default: alertDefaultIcon,
    info: alertInfoIcon,
    success: alertSucessIcon,
    warning: alertWarningIcon,
};
const defaultToastDuration = 3000;
export const ToastStack = (props) => {
    const { duration } = props;
    const dispatch = useSetAtom(toastMapState);
    const toastList = useAtomValue(selectToastList);
    const trueDuration = duration ?? defaultToastDuration;
    return (_jsx(RadixToast.Provider, { swipeDirection: "up", children: _jsx(RadixToast.Viewport, { className: "toast-viewport", children: toastList.map((toast, index) => {
                const iconSource = ICON_MAP[toast.status];
                const toastIndex = toastList.length - (index + 1);
                const toastDuration = trueDuration + toastIndex * trueDuration;
                return (_jsxs(RadixToast.Root, { "data-toast-index": toastIndex, className: `toast-root typog-body ${toast.status}`, open: true, onOpenChange: (open) => {
                        if (!open) {
                            dispatch({
                                type: ToastMapActionTypes.REMOVE,
                                toast,
                            });
                        }
                    }, duration: toastDuration, children: [_jsxs(RadixToast.Title, { className: "toast-title-block", children: [_jsx("div", { className: `icon status-icon ${toast.status}`, children: _jsx("img", { src: iconSource, alt: `${toast.status}` }) }), toast.title === '' ? null : (_jsx("div", { className: `toast-title-message typog-h3-med`, children: toast.title }))] }), _jsx(RadixToast.Description, { className: `toast-description typog-body`, children: toast.message }), _jsx(RadixToast.Close, { className: `icon close-icon ${toast.status}`, children: _jsx("img", { src: closeIcon, alt: `dismiss toast` }) })] }, `${toast.key}`));
            }) }) }));
};
//# sourceMappingURL=toast-stack.js.map